export default "__VITE_ASSET__DOAnLVa9__$_?format=webp__"